import React, { useEffect, useState } from 'react';
import { Drawer, Link, Space, Tabs, Tag } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ModalHeader from '@/components/Header/Modal';
import { fetchSingleOverview } from '@/slices/kafkaBrokerSlice';
import Summary from './Summary';
import Configuration from './Configuration';
import DataLogs from './DataLogs';

const { TabPanel } = Tabs;

function Detail({ detail, clusterName, fetchSingleOverview }) {
  const [visible, setVisible] = useState(false);

  const brokerId = detail?.brokerId;

  const handleClose = () => setVisible(false);

  useEffect(() => {
    if (visible) {
      fetchSingleOverview({ clusterName, brokerId });
    }
  }, [visible, clusterName, brokerId, fetchSingleOverview]);

  return (
    <>
      <Link theme='primary' onClick={() => setVisible(true)}>
        <Space align='center' size={2}>
          {detail.leader && (
            <Tag theme='primary' variant='light'>
              controller
            </Tag>
          )}
          {detail.brokerId}
        </Space>
      </Link>
      <Drawer
        visible={visible}
        size={'80%'}
        destroyOnClose
        header={
          <ModalHeader tags={[clusterName, `${detail.host}:${detail.port}`, detail.version]}>
            Broker
          </ModalHeader>
        }
        footer={null}
        onClose={handleClose}
      >
        <Body>
          <Summary clusterName={clusterName} brokerId={detail.brokerId} />
          <Tabs defaultValue={1}>
            <TabPanel style={{ paddingTop: 20 }} value={1} label='Configuration' destroyOnHide>
              <Configuration brokerId={brokerId} clusterName={clusterName} />
            </TabPanel>
            <TabPanel value={2} label='DataLogs' destroyOnHide style={{ paddingTop: 20 }}>
              <DataLogs brokerId={brokerId} clusterName={clusterName} />
            </TabPanel>
          </Tabs>
        </Body>
      </Drawer>
    </>
  );
}

export default connect(null, {
  fetchSingleOverview,
})(Detail);

const Body = styled.div`
  margin-top: -15px;
`;
